import ProjectCard from '@/components/ProjectCard';
import { Main } from '@/layouts/main';
import sanityClient from '@/lib/sanityClient';
import { projectsQuery } from '@/lib/sanityQueries';

import type { Project } from '@/types';
import type { NextPage } from 'next';
import Head from 'next/head';

interface Props {
  projects: Project[];
}

const Projects: NextPage<Props> = ({ projects }) => {
  return (
    <>
      <Head>
        <title>chrisbailey.dev - projects</title>
        <meta name="description" content="list of projects have either worked on or created" />
      </Head>
      <Main>
        <h2 className="text-3xl font-extrabold text-indigo-500 lowercase">
          projects
        </h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 prose">
          {projects.map((project) => (
            <ProjectCard project={project} key={project._id} />
          ))}
        </div>
      </Main>
    </>
  );
};

export async function getStaticProps() {
  const projects: Project[] = await sanityClient.fetch(projectsQuery);
  return {
    props: { projects }
  };
}

export default Projects;
